import { render, staticRenderFns } from "./dog-point-vineyards.vue?vue&type=template&id=79b1d98d&scoped=true"
import script from "./dog-point-vineyards.vue?vue&type=script&lang=js"
export * from "./dog-point-vineyards.vue?vue&type=script&lang=js"
import style0 from "./dog-point-vineyards.vue?vue&type=style&index=0&id=79b1d98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b1d98d",
  null
  
)

export default component.exports